<template>
  <template v-if="!pending && medium?.originalData">
    <NuxtImg
      provider="cloudflare"
      :src="(medium?.originalData.indexOf('/') === 0 ? '':'/') + medium?.originalData"
      :alt="altText"
      :title="title"
      :densities="densities"
      :width="width"
      :preset="preset"
      :loading="lazy ? 'lazy' : undefined"
      :draggable="!dragRestriction"
    />
  </template>
  <template v-else-if="pending && imagePlaceHolder != undefined">
    <NuxtImg
      provider="cloudflare"
      :src="imagePlaceHolder"
      :alt="altText"
      :title="title"
      :densities="densities"
      :width="width"
      :preset="preset"
      :loading="lazy ? 'lazy' : undefined"
      :draggable="!dragRestriction"
    />
  </template>
</template>
<script setup lang="ts">
import { inject } from 'vue';
import { getMedium } from "~/composables/ExpApi/expCache";

interface Props {
  mediumId: string;
  dragRestriction?: boolean;
  width?: number;
  preset?: string;
  lazy?: boolean;
  debug?: boolean;
  imagePlaceHolderSrc?: string;
  densities?: string;
  title?: string;
}

const props = withDefaults(defineProps<Props>(), {
  dragRestriction: true,
  lazy: true,
  debug: false,
  densities: 'x1',
});

const imagePlaceHolder = props?.imagePlaceHolderSrc ? props?.imagePlaceHolderSrc : inject('ImagePlaceHolder', '');

const { pending, data: medium } = await getMedium(props?.mediumId);

const altText = computed(() => {
  return medium?.value?.alt || medium?.value?.title || medium?.value?.name || props?.title || '';
});

const title = computed(() => {
  return props?.title || medium?.value?.title || medium?.value?.alt || medium?.value?.name || '';
});
</script>
